import React from 'react';
import {
  WhiteInstantSearchBuilder,
  MenuSelectPanel,
  NoResults,
  Pagination,
  SearchBox,
  SortBy,
  ToggleRefinement,
} from '@white-nl/instantsearch-components';

import { CheckSharpSolid, MagnifyingGlassSharpRegular, XmarkSharpRegular } from '../components/ui/icons';
import { Hit as PartnersHit } from '../components/partners/results/Hit';
import { ClearIndicator, DropdownIndicator } from '../components/ui/React-select';
import Stats from '../components/ui/metadata/Stats';
import Loading from '../components/partners/results/Loading';

const settings = document.getElementById('section-filters')?.dataset || {};
const whiteInstantSearchPartners = new WhiteInstantSearchBuilder();
whiteInstantSearchPartners
  .setHitsPerPage(18)
  .addAdditionalData({
    hitsPerPage: 18,
    categoryLabel: Craft.t('partners', 'Category'),
  })
  .addSearchingComponent([
    {
      settings: {
        classNames: {
          submit: 'submit',
          reset: 'reset',
          loadingIndicator: 'reset',
          input: 'form-control',
        },
        submitIconComponent: () => (
          <MagnifyingGlassSharpRegular />
        ),
        resetIconComponent: () => (
          <XmarkSharpRegular />
        ),
        placeholder: Craft.t('partners', 'Looking for a partner?'),
        translations: {
          submitButtonTitle: Craft.t('partners', 'Submit the search query'),
          resetButtonTitle: Craft.t('partners', 'Clear the search query'),
        },
      },
      component: SearchBox,
    },
  ])
  .addHitComponent([
    {
      settings: {
        loading: {
          translations: {
            loading: Craft.t('partners', 'Loading partners...'),
          },
        },
        noResults: {
          translations: {
            noResults: Craft.t('partners', 'Sorry, we can\'t find any partners!'),
            refinements: Craft.t('partners', 'Try to reset your applied filters.'),
            query: Craft.t('partners', 'Please try another query.'),
          },
        },
      },
      component: PartnersHit,
      loadingComponent: Loading,
      noResultsComponent: NoResults,
    },
  ])
  .addMenu([
    {
      settings: {
        attribute: 'country',
        limit: 999,
        translations: {
          defaultOptionText: Craft.t('partners', 'All countries'),
        },
        sortBy: (a, b) => {
          const nameA = a.name.toLocaleLowerCase();
          const nameB = b.name.toLocaleLowerCase();
          return nameA.localeCompare(nameB, document.documentElement.lang);
        },
        classNames: {
          control: () => 'form-select filter',
          menu: () => 'form-select-list',
        },
        isSearchable: true,
        isClearable: true,
        unstyled: true,
        components: {
          ClearIndicator,
          DropdownIndicator,
        },
        panelSettings: {
          collapsiblePanelSettings: {
            classNames: {
              root: 'form-wrap',
              header: 'filter-title h4',
            },
            defaultExpanded: true,
            canCollapse: false,
          },
          header: Craft.t('partners', 'Countries'),
        },
      },
      component: MenuSelectPanel,
    },
  ])
  .addToggleRefinement(
    [
      {
        settings: {
          attribute: 'datacenter',
          label: Craft.t('partners', 'Data centre partners'),
          on: true,
          classNames: {
            label: 'btn btn-datacenter',
          },
        },
        component: ToggleRefinement,
      },
    ],
    '#white-instant-search-toggle-refinements',
  )
  .addToggleRefinement(
    [
      {
        settings: {
          attribute: 'premium',
          label: Craft.t('partners', 'Premium partners'),
          on: true,
          classNames: {
            label: 'btn btn-premium',
          },
        },
        component: ToggleRefinement,
      },
    ],
    '#white-instant-search-toggle-refinements',
  )
  .addPaginationComponent([
    {
      settings: {
        showFirst: false,
        showLast: false,
        classNames: {
          list: 'pagination',
          item: 'page-item',
          previousPageItem: 'previous',
          selectedItem: 'active',
          disabledItem: 'disabled',
          nextPageItem: 'next',
          link: 'page-link',
        },
        translations: {
          previousPageItemText: Craft.t('pagination', 'Previous'),
          previousPageItemAriaLabel: Craft.t('pagination', 'Go to previous page'),
          nextPageItemText: Craft.t('pagination', 'Next'),
          nextPageItemAriaLabel: Craft.t('pagination', 'Go to next page'),
        },
      },
      component: Pagination,
    },
  ])
  .addStatsComponent([
    {
      settings: {
        translations: {
          resultsFound: Craft.t('partners', 'results found'),
          resultFound: Craft.t('partners', 'result found'),
        },
      },
      component: Stats,
    },
  ])
  .addSortByComponent([
    {
      settings: {
        items: [
          { label: Craft.t('partners', 'Most relevant first'), value: settings.mappingName || '' },
          {
            label: Craft.t('partners', 'Alphabet A-Z'),
            value: `${settings.mappingName || ''}_title_asc`,
          },
          {
            label: Craft.t('partners', 'Alphabet Z-A'),
            value: `${settings.mappingName || ''}_title_desc`,
          },
          {
            label: Craft.t('partners', 'Zip Code (Ascending)'),
            value: `${settings.mappingName || ''}_postalCode_asc`,
          },
          {
            label: Craft.t('partners', 'Zip Code (Descending)'),
            value: `${settings.mappingName || ''}_postalCode_desc`,
          },
        ],
        unstyled: true,
        components: {
          DropdownIndicator,
        },
      },
      component: SortBy,
    },
  ])
  .addCurrentRefinementsComponent(
    [{
      settings: {
        excludedAttributes: ['category.title'],
      },
      component: ({ currentRefinements }) => (
        currentRefinements.items.reduce((a, b) => a + b.refinements.length, 0) > 0
        && (<CheckSharpSolid iconClass="check-icon" />)
      ),
    }],
    '.filters-icon',
  )
  .addStatsComponent([{ component: ({ stats }) => (`(${stats.nbHits})`) }], '.hits-count')
  .setScrolling({
    includeAttributes: ['page'],
  });
window.whiteInstantSearchPartners = whiteInstantSearchPartners;
